/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 07/12/21
 */

import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export const useQuery = () => {
    const location = useLocation();
    return useMemo(() => {
        const params = new URLSearchParams(location.search);
        const paramsObj: Record<string, string | undefined> = {};
        const iterator = params.entries();
        let item = iterator.next();
        while (!item.done) {
            paramsObj[item.value[0]] = item.value[1];
            item = iterator.next();
        }
        return paramsObj;
    }, [location.search]);
};
